<template>
  <div class="my-5">
    <div class="has-text-centered">
      <p>כל הכבוד על ההשמה שלכם 🏆 💪</p>
      <p>לפני שאנחנו מביאים את השומים...</p>
    </div>
    <div class="is-flex mt-6 is-justify-content-center">
      <button @click="confirm" class="button is-info mx-3">כן! עשינו השמה 🥳</button>
      <button @click="reject" class="button is-danger mx-3">נלחץ לי בטעות 🙄</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'vested-confirmation',
  props: {
    payload: {
      type: Object
    }
  },
  methods: {
    ...mapMutations('modals', ['removeModalById', 'create']),
    reject () {
      this.$utils.emit('show_toast', { text: 'לא נורא! בפעם הבאה' })
      this.close()
    },
    confirm () {
      this.create({ designator: 'vested-modal', component_name: 'VestedForm', data: this.payload.data, modal_title: 'Vested' })
      this.close()
    },
    close () {
      this.removeModalById(this.payload.modal_id)
    }
  }
}

</script>
